import SecundButton from 'components/form/buttons/secundButton';
import MiniPopUp from 'components/modal/miniPopUp';
import PanelBoxLayout from 'components/layout/panelBox';

import { Formik } from 'formik';
import Gap from 'components/gap';
import PrimaryButton from 'components/form/buttons/primaryButton';
import { SetStateAction, useState } from 'react';
import DropDown from 'components/form/dropDown';
import OutlineButton from 'components/form/buttons/outLineButton';

import * as S from './styles';
import * as T from 'common/types';
import { absenceLocalApprovalStatusEnum } from 'common/enums';

interface IProps {
  setFilter: SetStateAction<any>;
  filter: any;
}

export default function TicketFilterPopup({ setFilter, filter }: IProps) {
  const [show, setShow] = useState<boolean | undefined>(undefined);

  console.log(filter);

  return (
    <S.Content>
      <MiniPopUp
        popUpStyle={{ width: 245, padding: '0' }}
        show={show}
        buttonNode={
          <div style={{ position: 'relative' }}>
            <SecundButton
              hasIcon={true}
              icon="/icons/stroke/filter.svg"
              iconStyle={{ background: 'none' }}
              style={{ background: '#8A93AC' }}
              colorIcon="var(--white)"
              onClick={() => setShow(true)}
            >
              Filters
            </SecundButton>
            {filter?.status || filter?.orderBy !== 'createdAt' || filter?.orderType !== 'desc' ? <S.Badge /> : <></>}
          </div>
        }
      >
        <PanelBoxLayout
          style={{ padding: 15 }}
          titleStyle={{ color: '#2D3748', fontSize: 14 }}
          title="Filters"
          icon="/icons/stroke/filter.svg"
        >
          <Formik
            initialValues={{
              orderBy: 'createdAt',
              orderType: 'desc',
              status: ''
            }}
            // validationSchema={ValidationLogin}
            onSubmit={(values, { setSubmitting }) => {
              setFilter({ ...filter, ...values, page: 1 });
              setSubmitting(false);
              setShow(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              // handleChange,
              handleSubmit,
              // isSubmitting,
              setValues,
              resetForm
            }) => (
              <>
                <DropDown
                  label="Status"
                  list={[
                    { id: '', title: 'All' },
                    { id: absenceLocalApprovalStatusEnum.APPROVED, title: absenceLocalApprovalStatusEnum.APPROVED },
                    { id: absenceLocalApprovalStatusEnum.AWAITING, title: absenceLocalApprovalStatusEnum.AWAITING },
                    { id: absenceLocalApprovalStatusEnum.DENIED, title: absenceLocalApprovalStatusEnum.DENIED }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      status: e.id as any
                    });
                  }}
                  placeholder="Select Status"
                  message={touched.status && (errors.status as any)}
                  error={errors.status as unknown as boolean}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="10px" />
                <DropDown
                  label="Order Type"
                  list={[
                    { id: 'createdAt', title: 'Created At' },
                    { id: 'updatedAt', title: 'Updated At' },
                    { id: 'absenceType', title: 'Absence Type' }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      orderBy: e.id as any
                    });
                  }}
                  placeholder="Select Order By"
                  message={touched.orderBy && (errors.orderBy as any)}
                  error={errors.orderBy as unknown as boolean}
                  defaultValue={{ id: values.orderBy, title: values.orderBy }}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="20px" />
                <DropDown
                  label="Order Type"
                  list={[
                    { id: 'asc', title: 'Asc' },
                    { id: 'desc', title: 'Desc' }
                  ]}
                  onChange={(e: T.Form.ListDropdownItem) => {
                    setValues({
                      ...values,
                      orderType: e.id as any
                    });
                  }}
                  placeholder="Select Order By"
                  message={touched.orderBy && (errors.orderBy as any)}
                  error={errors.orderBy as unknown as boolean}
                  defaultValue={{ id: values.orderType, title: values.orderType }}
                  inputStyle={{
                    height: 40,
                    borderRadius: 7,
                    fontSize: 12,
                    padding: '0 15px'
                  }}
                  labelStyle={{ fontSize: 12 }}
                />
                <Gap size="20px" />

                <PrimaryButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={handleSubmit}
                  // disabled={isSubmitting}
                >
                  Filter
                </PrimaryButton>

                <Gap size="15px" />

                <OutlineButton
                  style={{ width: '100%', height: 42, borderRadius: 8 }}
                  onClick={() => {
                    resetForm();
                    handleSubmit();
                    setShow(false);
                  }}
                  // disabled={isSubmitting}
                >
                  Reset
                </OutlineButton>
              </>
            )}
          </Formik>
        </PanelBoxLayout>
      </MiniPopUp>
    </S.Content>
  );
}
